import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from './MaterialSymbol';

const ExpandWrap = styled.div<{ $marginTop?: string; $padding?: string }>`
  margin-top: ${({ $marginTop }) => $marginTop ?? '0'};
  padding: ${({ $padding }) => $padding ?? '0'};
`;

const ArrowRotate = styled.div<{ $isOpened: boolean }>`
  display: flex;
  align-items: center;
`;

export default function ExpandableArrow({
  expanded,
  onChange,
  marginTop,
  padding,
}: {
  expanded: boolean;
  onChange?: (expanded: boolean) => void;
  marginTop?: string;
  padding?: string;
}) {
  return (
    <ExpandWrap
      onClick={onChange ? () => onChange(!expanded) : undefined}
      $marginTop={marginTop}
      $padding={padding}
    >
      <ArrowRotate $isOpened={expanded}>
        <MaterialSymbol icon="arrow_drop_down" color="var(--gray4c)" rounded />
      </ArrowRotate>
    </ExpandWrap>
  );
}
